export const THEME_ID = '684b1031-4272-52a1-9980-f55f15abe8e1';

export const FULL_CROP_INFO = {
  x: 0,
  y: 0,
  unit: 'percent',
  width: 100,
  height: 100,
};
